export const SET_APP_STATE_STATUS = 'SET_APP_STATE_STATUS';
export const setAppStateStatus = (appStateStatus) => ({
    type: SET_APP_STATE_STATUS,
    payload: appStateStatus,
});
